<template>
  <div class="wrp">
    <section>
      <!-- <div class="qrcode-wrp">
        <img src="@assets/img/qrcode.jpg" alt="">
      </div> -->
      <p class="success-icon">
        <van-icon color="#F65F5F" size=81px name="warning" />
      </p>
      <p class="success-text">开票二维码已失效</p>
      <p class="res-tit">请联系商家咨询</p>
    </section>
  </div>
</template>

<script>
import { Icon, SwipeItem, Swipe } from 'vant'
import { ConvertNumber, getQuery } from '@utils/basicUtil'
export default {
  data () {
    return {
      swiperList: [
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner1.png',
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner2.png',
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner3.png'
      ],
      company: '',
      money: '0',
      phone: '',
      email: ''
    }
  },
  mounted () {
    this.getQuery()
  },
  methods: {
    getQuery () {
      let queryObj = getQuery()
      this.company = queryObj.c || ''
      this.money = queryObj.m || '0'
      this.phone = queryObj.p || ''
      this.email = queryObj.e ? decodeURIComponent(queryObj.e) : ''
    },
    ConvertNumber (num) {
      return ConvertNumber(num)
    }
  },
  components: {
    [Icon.name]: Icon,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe
  }
}
</script>

<style lang="less" scoped src="./index.less"/>
